<!--
2023-11-02 YTW 印度排灯节
-->
<template>
  <div class="main-content" id="main-content">
    <div class="relative">
      <TopBack style="position: relative" :title="$t('lang.beginnersOnly.title')"/>
      <div class="banner">
        <img :src="bannerIn" alt="" v-if="$store.state.locale==='IN'"/>
        <img :src="banner" alt="" v-else/>
      </div>
      <div class="centerArea">
        <div class="bk"><img :src="bk" alt=""/></div>
        <div class="title">
          <div class="t1">{{ $t('lang.beginnersOnly.myDeposit') }}</div>
          <div class="t2">{{ $t('lang.beginnersOnly.toNext') }}</div>
        </div>
        <div class="amount">
          <div class="a1">{{ separateThousandInteger(myDeposit) }}</div>
          <div class="a2">{{ toNextReward > 0 ? separateThousandInteger(toNextReward) : 0 }}</div>
        </div>
        <div class="button" @click="goto('Deposit')">{{ $t('lang.beginnersOnly.deposit') }}</div>
      </div>
      <div class="table">
        <div class="tr">
          <div class="title">{{ $t('lang.beginnersOnly.deposit') }}</div>
          <div class="title">{{ $t('lang.beginnersOnly.award') }}</div>
        </div>
        <div class="tr" v-for="(item,index) in awards" :key="index">
          <div class="td">{{ separateThousandInteger(item.Amount) }}</div>
          <div class="td">{{ item.Award }}</div>
        </div>
      </div>
      <div class="claimButton" @click="claim" :style="{ background: mayCollectButton ? '' : 'grey' }">
        {{ $t('lang.shareFiesta.btn0') }}
      </div>
      <div class="myChoice">{{ $t('lang.beginnersOnly.myChoice') }} {{ choice }}</div>
      <div class="rules">
        <div class="title">{{ $t('lang.promotion.rules') }}</div>
        <div class="content">
          <p v-for="(rule,index) in $t('lang.beginnersOnly.rules')" :key="index">{{ rule }}</p>
        </div>
      </div>
    </div>
    <div class="panel" v-show="modalShow">
      <div class="modal">
        <div class="top">{{ $t('lang.beginnersOnly.congrats') }}</div>
        <div class="message">
          {{ changeWord($t('lang.beginnersOnly.message')) }}
        </div>
        <div class="buttons">
          <div class="btn" @click="collectReward(1)">{{ $t('lang.beginnersOnly.address') }}</div>
          <div class="btn" @click="collectReward(2)">{{ $t('lang.beginnersOnly.exchange') }}</div>
        </div>
        <div class="buttons">
          <div class="ok" @click="closePanel">{{ $t('lang.common.ok') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import next from '@/assets/images/beginnersOnly/next.svg'
import money from '@/assets/images/beginnersOnly/money.png'
import banner from '@/assets/images/beginnersOnly/banner.png'
import bannerIn from '@/assets/images/beginnersOnly/bannerIn.png'
import bk from '@/assets/images/beginnersOnly/bk.png'
import TopBack from '@/components/TopBack/index'
import request from '@/service'
import {separateThousandInteger, fetchBalance} from '@/utils'
import {Toast} from 'mint-ui'

export default {
  name: 'BeginnersOnly',
  data () {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      centerArea: '',
      bk,
      next,
      money,
      banner,
      bannerIn,
      myDeposit: 0,
      toNextReward: 0,
      mayCollectButton: false,
      isPhysicalGift: false,
      fetchBalance,
      separateThousandInteger,
      choice: '',
      awards: [],
      levelGet: {gift: 'iPhone15', award: '5000'},
      modalShow: false
    }
  },
  components: {
    TopBack
  },
  watch: {},
  created () {
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      const data = {userId: this.userInfo.UserId, campaignId: localStorage.getItem('cid')}
      request('post', '/innovation/deposit/task/get_data', data, true).then(res => {
        this.choice = res.MyAward
        this.myDeposit = res.MyDeposit
        this.toNextReward = res.ToNextReward
        this.mayCollectButton = res.MayCollectButton
        this.awards = res.Awards
        this.isPhysicalGift = res.IsPhysicalGift
        this.levelGet = {gift: res.MyAward, award: res.AwardAmount}
      })
    },
    goBack () {
      this.$router.go(-1)
    },
    goto (path) {
      this.$router.push('/' + path)
    },
    changeWord (message) {
      message = message.replace('{gift}', this.levelGet.gift)
      message = message.replace('{award}', this.levelGet.award)
      return message
    },
    claim () {
      if (this.mayCollectButton) {
        if (this.isPhysicalGift) {
          this.modalShow = true
        } else {
          this.collectReward(2)
        }
      } else {
        Toast(this.$t('lang.beginnersOnly.unavailable'))
      }
    },
    collectReward (type) {
      const data = {userId: this.userInfo.UserId, isPhysicalGift: type === 1}
      request('post', '/innovation/deposit/task/collect_reward', data).then(res => {
        if (res && res.Status === 1) {
          this.getData()
          this.closePanel()
          Toast(res)
          if (res.AwardType === 'deposit630_gift') { // 奖励gift
            this.fetchBalance()
            const msg = res.AwardAmount + this.$t('lang.beginnersOnly.issued')
            Toast(msg)
          } else if (res.AwardType === 'deposit630_discount') { // 奖励充赠券
            const msg = this.$t('lang.beginnersOnly.coupon').replace('{daySpan}', res.DiscountPeriodValidity)
            Toast({message: msg, duration: 5000})
          } else if (res.AwardType === 'deposit630_physical') {
            if (res.IsPhysicalGift) { // 实物奖励
              window.open('https://docs.google.com/forms/d/e/1FAIpQLSedVx4dUQ3i2j1sUvjr8MEHwNks2b6xQev27zFLD4xJPjVOrA/viewform?usp=sf_link')
            } else { // 实物兑换gift
              this.fetchBalance()
              const msg = res.AwardAmount + this.$t('lang.beginnersOnly.issued')
              Toast(msg)
            }
          }
        } else {
          Toast(this.$t('lang.common.fail'))
        }
      })
    },
    closePanel () {
      this.modalShow = false
    }
  }
}
</script>

<style lang="less" scoped>
.main-content {
  position: fixed;
  padding: 56px 0 0 0;
  width: 100vw;
  height: 100vh;
  background-color: #000000;
  display: flex;
  overflow-x: hidden;
  overflow-y: auto;

  .relative {
    position: relative;
    width: 100%;
    height: max-content;
    z-index: 0;
  }

  .banner {
    position: relative;
    width: 100vw;
    height: 45.101vw;
    overflow: hidden;

    img {
      width: 100%;
    }
  }

  .centerArea {
    position: relative;
    left: 50%;
    transform: translate(-50%);
    top: -0.3vw;
    width: 94.5vw;
    height: 16.667vw;
    padding-top: 2vw;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    text-align: center;
    background: radial-gradient(36.08% 100% at 50% 0%, #1D1D1D 0%, rgba(40, 40, 40, 0.17) 88.43%, rgba(46, 46, 46, 0.13) 100%);

    .bk {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 0;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .title {
      position: relative;
      z-index: 1;
      height: 100%;
      text-transform: capitalize;

      .t1 {
        font-family: Inter;
        font-size: 5.277vw;
        font-weight: 700;
        text-align: left;
        color: #FFFFFF;
      }

      .t2 {
        margin-top: 1.5vw;
        font-family: Inter;
        font-size: 3.333vw;
        text-align: left;
        color: #6D6D6D;
        font-weight: 500;
      }
    }

    .amount {
      position: relative;
      z-index: 1;
      height: 100%;

      .a1 {
        font-family: Inter;
        font-size: 5.277vw;
        font-weight: 700;
        text-align: left;
        color: #FFFFFF;
      }

      .a2 {
        z-index: 1;
        margin-top: 1.5vw;
        padding-left: 0.5vw;
        font-family: Inter;
        font-size: 3.333vw;
        font-weight: 500;
        text-align: left;
        color: #9A9A9A;
      }
    }

    .button {
      position: relative;
      margin-top: 1vw;
      width: 25.278vw;
      height: 8.333vw;
      line-height: 7.5vw;
      background: radial-gradient(56.64% 79.84% at 50% 50%, #464646 0%, rgba(0, 0, 0, 0) 100%);
      border: 0.5px solid #E2C18E;
      border-radius: 8vw;
      font-family: Inter;
      font-size: 4.444vw;
      font-weight: 500;
      color: #FFE0A5;
    }
  }

  .table {
    position: relative;
    top: 5vw;
    left: 50%;
    transform: translate(-50%);
    width: 93.333vw;

    .tr {
      width: 100%;
      height: 7.967vw;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      text-align: center;

      .title {
        width: 40vw;
        text-transform: capitalize;
        color: #FFFFFF;
        font-family: Inter;
        font-size: 4.722vw;
        font-weight: 700;

      }

      .td {
        text-transform: capitalize;
        width: 40vw;
        font-family: Inter;
        font-size: 4.166vw;
        font-weight: 500;
        color: #BABABA;
      }
    }
  }

  .table .tr:nth-child(even) {
    background: linear-gradient(90deg, rgba(18, 18, 18, 0) 0%, rgba(83, 81, 81, 0.175) 10.32%, rgba(109, 109, 109, 0.35) 50%, rgba(66, 66, 66, 0.2625) 88.5%, rgba(17, 17, 17, 0) 100%);
  }

  .claimButton {
    position: relative;
    top: 11.477vw;
    left: 50%;
    transform: translate(-50%);
    text-transform: lowercase;
    width: 74.444vw;
    height: 10.833vw;
    line-height: 10.833vw;
    border-radius: 0.8333vw;
    font-family: Inter;
    font-size: 5.833vw;
    font-weight: 500;
    text-align: center;
    background: linear-gradient(270.12deg, #DEBC86 -2.41%, #F7DEB8 113.36%);
    color: #000000;
  }

  .myChoice {
    position: relative;
    top: 16.6667vw;
    height: 8.811vw;
    text-align: center;
    color: #DCDCDC;
    font-family: Inter;
    font-size: 4.166vw;
    line-height: 8.811vw;;
    font-weight: 500;
    border-top: 0.277vw solid;
    border-bottom: 0.277vw solid;
    border-image-source: linear-gradient(90deg, rgba(109, 109, 109, 0) 0%, #C4C4C4 50%, rgba(211, 211, 211, 0) 100%);
    border-image-slice: 1;
  }

  .rules {
    position: relative;
    top: 21.6667vw;
    left: 50%;
    transform: translate(-50%);
    width: 90.555vw;
    height: max-content;
    padding-bottom: 10vw;

    .title {
      font-family: Inter;
      font-size: 6.111vw;
      font-weight: 700;
      line-height: 6.388vw;
      text-align: left;
      color: #FFFFFF;
      margin-bottom: 2vw;
    }

    .content {
      padding: 2vw 0 0 1.111vw;
      font-family: Inter;
      font-size: 4.166vw;
      font-weight: 500;
      line-height: 5.556vw;
      text-align: left;
      color: #FFFFFF;
      height: max-content;

      p {
        margin-bottom: 1vw;
      }
    }
  }

  .panel {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.66);

    .modal {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 83.333vw;
      height: 55.556vw;
      background: radial-gradient(55.26% 69.13% at 56.09% 47.9%, #151715 0%, #202020 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;
      border: 0.277vw solid #737373;
      border-radius: 4.166vw;

      .top {
        margin-top: 4vw;
        text-align: center;
        font-size: 5.556vw;
        font-weight: 700;
        color: #FFFFFF;
      }

      .message {
        position: relative;
        top: 3vw;
        left: 50%;
        transform: translate(-50%);
        width: 68.672vw;
        height: max-content;
        color: #C4C4C4;
        font-size: 3.888vw;
        font-weight: 400;
        line-height: 5.556vw;
        letter-spacing: 0.02em;
      }

      .buttons {
        position: relative;
        top: 8vw;
        left: 50%;
        transform: translate(-50%);
        display: flex;
        width: 69.444vw;
        height: 8.333vw;
        justify-content: space-between;

        .btn {
          width: 32.222vw;
          height: 8.333vw;
          line-height: 8.333vw;
          text-align: center;
          background: linear-gradient(270.12deg, #DEBC86 -2.41%, #F7DEB8 113.36%);
          font-family: Inter;
          font-size: 3.889vw;
          font-weight: 500;
          color: #000000;
          border-radius: 0.833vw;
        }

        .ok {
          margin-top: 3.8vw;
          width: 100%;
          text-align: center;
        }
      }
    }
  }
}

.main-content::-webkit-scrollbar {
  display: none
}

</style>



// WEBPACK FOOTER //
// src/pages/BeginnersOnly/index.vue